var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "badge", class: _vm.classes },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.badges.length
        ? _c("span", { staticClass: "badge-container" }, [
            _c(
              "span",
              { staticClass: "badge-wrapper", style: _vm.style },
              [
                _vm.tooltip
                  ? _vm._l(_vm.badges, function(badge) {
                      return _c(
                        "el-tooltip",
                        {
                          key: badge.label,
                          attrs: {
                            content: badge.label,
                            placement: "bottom-start"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "badge-item",
                              class: ["badge-item--" + badge.id]
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.content) +
                                  "\n                    "
                              )
                            ]
                          )
                        ]
                      )
                    })
                  : _vm._l(_vm.badges, function(badge) {
                      return _c(
                        "span",
                        {
                          key: badge.label,
                          staticClass: "badge-item",
                          class: [badge.bgcolor + "-bkg", badge.color]
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.content) +
                              "\n                "
                          )
                        ]
                      )
                    })
              ],
              2
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }